// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CartDrawerController from "./cart_drawer_controller"
application.register("cart-drawer", CartDrawerController)

import ScrollSpyController from "./scroll_spy_controller"
application.register("scroll-spy", ScrollSpyController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import LocationModalController from "./location_modal_controller"
application.register("location-modal", LocationModalController)

import LocationConfirmController from "./location_confirm_controller"
application.register("location-confirm", LocationConfirmController)

import OpsAlertsController from "./ops_alerts_controller"
application.register("ops-alerts", OpsAlertsController)

import KitchenTimerController from "./kitchen_timer_controller"
application.register("kitchen-timer", KitchenTimerController)

import InteractionButtonController from "./interaction_button_controller"
application.register("interaction-button", InteractionButtonController)

import NewCardAlertController from "./new_card_alert_controller"
application.register("new-card-alert", NewCardAlertController)

import AccountMenuController from "./account_menu_controller"
application.register("account-menu", AccountMenuController)

import CheckoutSignupController from "./checkout_signup_controller"
application.register("checkout-signup", CheckoutSignupController)

import HorizontalScrollController from "./horizontal_scroll_controller"
application.register("horizontal-scroll", HorizontalScrollController)

import ProductModalController from "./product_modal_controller"
application.register("product-modal", ProductModalController)

import AddressPickerController from "./address_picker_controller"
application.register("address-picker", AddressPickerController)

import BranchPickerController from "./branch_picker_controller"
application.register("branch-picker", BranchPickerController)

import PosSettleController from "./pos_settle_controller"
application.register("pos-settle", PosSettleController)

import PosOpenChecksController from "./pos_open_checks_controller"
application.register("pos-open-checks", PosOpenChecksController)

import PosMobileCheckController from "./pos_mobile_check_controller"
application.register("pos-mobile-check", PosMobileCheckController)

import CheckLineNoteController from "./check_line_note_controller"
application.register("check-line-note", CheckLineNoteController)

import ScrollMemoryController from "./scroll_memory_controller"
application.register("scroll-memory", ScrollMemoryController)

import MarketingNavController from "./marketing_nav_controller"
application.register("marketing-nav", MarketingNavController)

import MarketingFaqController from "./marketing_faq_controller"
application.register("marketing-faq", MarketingFaqController)

import MarketingContactFormController from "./marketing_contact_form_controller"
application.register("marketing-contact-form", MarketingContactFormController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import PinKeypadController from "./pin_keypad_controller"
application.register("pin-keypad", PinKeypadController)

import IdleWatcherController from "./idle_watcher_controller"
application.register("idle-watcher", IdleWatcherController)

import ManagerApprovalController from "./manager_approval_controller"
application.register("manager-approval", ManagerApprovalController)

import ManagerApprovalModalController from "./manager_approval_modal_controller"
application.register("manager-approval-modal", ManagerApprovalModalController)

import PosSensitiveActionController from "./pos_sensitive_action_controller"
application.register("pos-sensitive-action", PosSensitiveActionController)

import MoneyInputController from "./money_input_controller"
application.register("money-input", MoneyInputController)

import ShiftCountdownController from "./shift_countdown_controller"
application.register("shift-countdown", ShiftCountdownController)

import { registerControllers } from "@radioactive-labs/plutonium"
registerControllers(application)
